export const fmtDate = (iso, withTime = false) => {
  if (!iso) return null;
  return new Intl.DateTimeFormat("nl-NL", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
    timeZone: "Europe/Amsterdam",
  }).format(new Date(iso));
};

export const fmtShort = (iso) => {
  if (!iso) return "";
  return new Intl.DateTimeFormat("nl-NL", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Amsterdam",
  }).format(new Date(iso));
};

export const fmtRange = (start, end) => {
  if (!end) return fmtDate(start);
  const s = new Date(start);
  const e = new Date(end);
  const day = (d) =>
    new Intl.DateTimeFormat("nl-NL", { day: "numeric", timeZone: "Europe/Amsterdam" }).format(d);
  const monthYear = (d) =>
    new Intl.DateTimeFormat("nl-NL", { month: "long", year: "numeric", timeZone: "Europe/Amsterdam" }).format(d);
  return `${day(s)} – ${day(e)} ${monthYear(e)}`;
};
